import { appWerklijstG4De } from './golf4App.de.js';
// Duits (de-DE), werklijstApp: zelfde vorm als werklijstApp.nl.ts (golf 3-integratie). Alleen de
// schermteksten; de punten zelf blijven Nederlands (docs/werklijst.json).
export const appWerklijstDe = {
    ...appWerklijstG4De,
    title: 'Arbeitsliste',
    subtitle: 'Nur für dich als Administrator · aktualisiert {when}',
    progress: '{done} von {total} fertig',
    progressLabel: 'Fortschritt: {done} von {total} Punkten fertig',
    progressRegion: 'Fortschritt',
    status: {
        waiting_on_you: 'Wartet auf dich',
        in_progress: 'In Arbeit',
        planned: 'Geplant',
        later: 'Später',
        done: 'Fertig',
    },
    filterAll: 'Alle',
    filterLabel: 'Zeigen',
    filterActive: 'Du siehst jetzt nur: {status}',
    showAll: 'Alle zeigen',
    needsYou: 'Was ich von dir brauche',
    needsYouCount: {
        one: 'Ein Punkt wartet auf dich.',
        other: '{count} Punkte warten auf dich.',
    },
    show: 'Ansehen',
    doneAt: 'Fertig am {when}',
    whatIsIt: 'Was ist das?',
    yourAction: 'Was musst du tun?',
    numberLabel: 'Punkt {n} aus deinem Feedback',
    groupCount: '{done} von {total} fertig',
    emptyTitle: 'Nichts mit diesem Stand',
    emptyBody: 'Wähle oben einen anderen Stand oder Alle.',
    unavailable: 'Die Arbeitsliste lässt sich gerade nicht lesen. Versuche es später noch einmal.',
};
//# sourceMappingURL=werklijstApp.de.js.map